import React from "react";
import "./Education.css";
import EducationCard from "../../components/educationCard/EducationCard";
import {educationInfo} from "../../portfolio";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import build from "../../assets/lottie/build.json";


export default function Education() {
  if (educationInfo.display) {
    return (
      <div className="education-container">
        <div className="edu-container">
          <div className="education-section" id="education">
          <h1 className="education-heading">Education</h1>
          <div className="education-card-container">
          {educationInfo.schools.map((school, i) => (
            <EducationCard key={i} school={school} />
          ))}
        </div>
        </div>
          <div className="edu-right">
            <DisplayLottie animationData={build}/>
          </div>
        </div>
      </div>
    );
  }
  return null;
}
